import React from 'react';
import { IconCheck } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './StatsSection.css';

const StatsSection = () => {
  const { t } = useLanguage();
  const stats = [
    { value: t.statsSection.stat1Value, label: t.statsSection.stat1Label, description: t.statsSection.stat1Desc },
    { value: t.statsSection.stat2Value, label: t.statsSection.stat2Label, description: t.statsSection.stat2Desc },
    { value: t.statsSection.stat3Value, label: t.statsSection.stat3Label, description: t.statsSection.stat3Desc },
  ];

  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const gridReveal = useScrollReveal({ threshold: 0.15 });

  return (
    <section className="stats-section-fox">
      <div className="stats-section-fox__container">
        <div ref={headerReveal.ref} className={`stats-section-fox__header reveal ${headerReveal.isRevealed ? 'reveal--visible' : ''}`}>
          <span className="stats-section-fox__label">{t.statsSection.label}</span>
          <h2 className="stats-section-fox__title">{t.statsSection.title}</h2>
        </div>
        <div ref={gridReveal.ref} className={`stats-section-fox__grid reveal--fade ${gridReveal.isRevealed ? 'reveal--visible' : ''}`}>
          {stats.map((stat, index) => (
            <div key={index} className="stats-section-fox__card reveal-child">
              <div className="stats-section-fox__card-content">
                <span className="stats-section-fox__value">{stat.value}</span>
                <span className="stats-section-fox__card-label">{stat.label}</span>
                <span className="stats-section-fox__card-description">{stat.description}</span>
              </div>
              <span className="stats-section-fox__arrow"><IconCheck size={18} /></span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
